export default __webpack_public_path__ + "static/media/image-gallery-2.dc922c50.jpg";